<div>
  <app-line-item-modal
    [addColTableData]="addColTableData"
    [stdLineItems]="stdLineItems"
    [max]="max"
    [createSource]="createSource"
    maxHeight="200px"
    [tickers]="tickers"
    lineItemInputId="createCompsLiModalLineItemInput"
    [marketItemsData]="marketItemsData"
    (updateComp)="saveCompsLineItems($event)"
  >
  </app-line-item-modal>
  <div>
    <va-period-filter
      [periodData]="yearTypeData"
      className="line-modal-period-filter"
      (onApply)="handlePeriodApply($event)"
      [popoverPlacement]="'topLeft'"
      [filterWidthVariation]="3"
      [dataAvailable]="periodsWithAvailableDataForPopup"
    ></va-period-filter>
    <!-- <app-comps-year-type-filter
      [filterData]="filterData"
      compType="TimeSeries"
      createComp="true"
      [yearTypeData]="yearTypeData"
      (saveYearType)="saveCompsYearType($event)"
      [openedForAddIn]="openedForAddIn"
    ></app-comps-year-type-filter> -->
  </div>
</div>
